import {
  VLO_GETPOOL_COMPLETE,
  VLO_CARGANDO_COMPLETE,
  VLO_GETMOVILES_COMPLETE,
  VLO_GETPROPERTIES_COMPLETE,
  VLO_SETMOVIL_COMPLETE,
  VLO_GETOPCIONES_COMPLETE,
} from "../../const/actionTypes";
import { get } from "lodash";

const initialState = {
  pool: [],
  propios: [],
  propiedades: [],
  opciones: [],
  cargando: true,
  movil: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case VLO_GETPOOL_COMPLETE:
      return { ...state, pool: get(action, "payload") };
    case VLO_GETMOVILES_COMPLETE:
      return { ...state, propios: get(action, "payload") };
    case VLO_CARGANDO_COMPLETE:
      return { ...state, cargando: get(action, "payload") };
    case VLO_GETPROPERTIES_COMPLETE:
      return { ...state, propiedades: get(action, "payload") };
    case VLO_SETMOVIL_COMPLETE:
      return { ...state, movil: get(action, "payload") };
    case VLO_GETOPCIONES_COMPLETE:
      return { ...state, opciones: get(action, "payload") };
    default:
      return { ...state };
  }
}
